import { Box, Grid, Link } from "@mui/material";
import moment from "moment";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  NumberField,
  RaRecord,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { UserType } from "../../enums/common";
import CallButton from "../Common/CallButton/CallButton";
import { formatUTCDateTimeWithSeconds } from "../../utils/DateTimeUtils";

const CookLeavesShow = (props: any) => { 
  return (
    <Show {...props} actions={false}>
      <Box sx={{display:"flex",flexDirection:"column"}}>
      <Grid container spacing={2}>
        <Grid item>
          <SimpleShowLayout>
            <FunctionField 
              label="Cook Id" 
              render={(record: RaRecord | undefined) => (
                <Link href={`/#/Cooks/${record?.cookId}/show`}>
                  {record?.cookId}
                </Link>
              )} 
            />
            <TextField label="Cook First Name" source="cookFirstName" />
            <TextField label="Cook Last Name" source="cookLastName" />
            <FunctionField label= "Cook Phone Number" render={(record: any) => <CallButton toPhoneNumber={record?.cookPhoneNumber} userType={UserType.COOK} referenceId={record?.id} referenceModelName="COOK_LEAVES_V3"/>}/>
          </SimpleShowLayout>
        </Grid>
        <Grid item>
          <SimpleShowLayout>
            <TextField label="Cook Zoho Id" source="cookZohoId" />
            <TextField label="Category" source="category" />
            <NumberField label="Leave Id" source="id" />
            <TextField label="Leave Type" source="leaveType" />
          </SimpleShowLayout>
        </Grid>
        <Grid item>
          <SimpleShowLayout>
            <TextField label="Leave Source" source="leaveSource" />
            <FunctionField
              label="Deleted By"
              render={(record: RaRecord) =>
                record?.leaveSource === "centaurus" && record?.deletedById ? (
                  <Link href={`/#/AdminUsers/${record.deletedById}/show`}>
                    {record.deletedById}
                  </Link>
                ) : "-"
              }
            />
            <TextField label="Notes" source="notes" />
            <TextField label="Requested By" source="requestedBy" />
            <TextField label="Reason" source="notes"/>
            <TextField label="Emergency Leave" source="isEmergencyLeave"/>
            <FunctionField
              label="Created By"
              render={(record: RaRecord) =>
                record?.createdBy ? (
                  <Link
                    href={
                      record?.createdByType === "COOK"
                        ? `/#/Cooks/${record.createdBy}/show`
                        : `/#/AdminUsers/${record.createdBy}/show`
                    }
                  >
                    {record.createdBy}
                  </Link>
                ) : "-"
              }
            />
            <TextField label="Created By Type" source="createdByType" />
            <FunctionField label="Leave Duration" render={(record: RaRecord) => {
            if (record?.leaveType ==="LONG_LEAVE") {
                return (
                <div style={{display:"flex",fontWeight:"600",gap:8}}>
                  <div>{moment.utc(record?.leaveStartDate).format('DD MMM YYYY')+" "+record?.startTime+""}</div>
                  <div>{" - "+moment.utc(record?.leaveEndDate).format('DD MMM YYYY')+" "+record?.endTime+""}</div>
                </div>
              )
            }
            else{
              if(record?.leaveType ==="SHORT_LEAVE"&&(record?.leaveStartDate===record?.leaveEndDate)){
                return(
                <div style={{display:"flex",fontWeight:"600",gap:8}}>
                  <div>{record?.startTime+" - "+record?.endTime}</div>
                  <div>{"( "+moment.utc(record?.leaveEndDate).format('DD MMM YYYY')+" )"}</div>
                </div>
                )
              }
              else{
                return(
                <div style={{display:"flex",fontWeight:"600",gap:8}}>
                  <div>{record?.startTime+" - "+record?.endTime}</div>
                  <div>{"( "+moment.utc(record?.leaveStartDate).format('DD MMM YYYY')+" - "+moment.utc(record?.leaveEndDate).format('DD MMM YYYY')+" )"}</div>
                </div>
                )
              }
            }
          }} />
          </SimpleShowLayout>
        </Grid>
        <Grid item>
          <SimpleShowLayout>
            <FunctionField label="Created At" render={(record: RaRecord) => {
              if (record?.createdAt) {
                return (
                  <>
                    <div>{formatUTCDateTimeWithSeconds(record?.createdAt)}</div>
                  </>
                )
              }
            }} />
            <FunctionField label="Updated At" render={(record: RaRecord) => {
              if (record?.updatedAt) {
                return (
                  <>
                    <div>{formatUTCDateTimeWithSeconds(record?.updatedAt)}</div>
                  </>
                )
              }
            }} />
          </SimpleShowLayout>
        </Grid>
      </Grid>
      <Box mt="1rem">
        <ArrayField label="CUSTOMER DETAILS" source="customerDetails">
          <Datagrid bulkActionButtons={false}>
            <TextField source="customerFirstName" />
            <TextField source="customerLastName" />
            <TextField source="customerMobile" />
            <TextField source="houseId" />
            <TextField source="locality" />
            <TextField source="address" />
            <TextField source="city" />
            <TextField source="slot" />
            <FunctionField label="absentDate" render={(record: any) => record?.absentDate ? moment(record.absentDate).format('DD MMM YYYY') : '-'} />
          </Datagrid>
        </ArrayField>
        </Box>
      </Box>
    </Show>
  );
};

export default CookLeavesShow;
